<div class="content">
  <div class="user-to-groups">
    <div class="group">Select roles</div>
    <div class="group-list add_user">
      <div class="group-list-item"
           *ngFor="let role of step.dataSource"
           (click)="flipValue(role)"
           [ngClass]="{disabledListItem: role.disabled}"
      >
        <ng-container>
          <mat-checkbox *ngIf="!role.disabled"
            color="primary" [disabled]="role.disabled"
                        [checked]="role.isChecked" class="selectedcheckBox" aria-label="role selection"
                        (click)="clickDetected($event)"
          ></mat-checkbox>
          <div class="group-label">
            <div>{{role.name}}</div>
            <div class="smaller group-desc" *ngIf="!role.disabled">{{role.description}}</div>
          </div>
          <div class="smaller" *ngIf="role.disabled">This role is opposite to another you have selected and cannot be chosen.</div>
        </ng-container>
      </div>
    </div>

  </div>
</div>
